import {RootState} from "../../../stores";
import {IPowerItem} from "../sample-data/power";

export const getTotalPower = (state: RootState) => {
    const power = Object.values(state.content.power) as IPowerItem[][];
    const lastPowers = power.map((p) => p[p.length - 1].observed);
    return lastPowers.reduce((pre, cur) => pre + cur);
}

export const getLastPower = (id: string) => (state: RootState) => {
    const powers = state.content.power[id];
    return powers ? powers[powers.length - 1] : undefined
};

export const getLines = (state: RootState) => state.content.lines;

export const getWind = (state: RootState) => {
    const wind = state.content.wind;
    return Object.keys(wind).map(name => {
        let velocity = wind[name][1];
        if (velocity < 1) {
           velocity = 0.1;
        } else if (velocity < 5) {
            velocity = 1;
        } else if (velocity < 10) {
            velocity = 2;
        } else {
            velocity = 3;
        }
        return {
            name: name.substring(name.length - 3),
            velocity
        }
    })
};

export const getEvents = (state: RootState) => state.content.events;

const ContentSelector = {
    getTotalPower,
    getLastPower,
    getLines,
    getWind,
    getEvents,
}

export default ContentSelector;
